import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import AdmissionForm from '../components/admissions/AdmissionForm';
import { CalendarIcon, FileTextIcon, CheckSquareIcon, CreditCardIcon } from 'lucide-react';
import Tabs from '../components/ui/Tabs';
import Alert from '../components/ui/Alert';
import Button from '../components/ui/Button';
import Badge from '../components/ui/Badge';
const Admissions = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  // Assuming academic year starts in September (month 8)
  const isAdmissionOpen = currentMonth >= 3 && currentMonth <= 7; // April to August
  return <div className="min-h-screen bg-white" data-id="element-1727">
      <PageHeader title="Admissions" description="Join our community of learners and future leaders. Discover the admission process, requirements, and how to apply to Isonyin Grammar School." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Admissions',
      path: '/admissions'
    }]} buttons={<>
            <Button href="#apply" variant="primary" size="lg" animation="scale" data-id="element-1729">
              Apply Now
            </Button>
            <Button href="#requirements" variant="outline" size="lg" className="bg-blue-800/50 border-white text-white hover:bg-blue-700" data-id="element-1730">
              View Requirements
            </Button>
          </>} data-id="element-1728" />
      <div className="container mx-auto px-4 py-12" data-id="element-1731">
        {/* Admission Status Alert */}
        {isAdmissionOpen ? <Alert variant="success" title="Admissions Open for 2023/2024 Academic Session" className="mb-8" data-id="element-1732">
            We are currently accepting applications for the 2023/2024 academic
            session. The deadline for submission is August 15, 2023.
          </Alert> : <Alert variant="info" title="Admissions for 2023/2024 Academic Session" className="mb-8" data-id="element-1733">
            Admissions for the 2023/2024 academic session will open in April
            2023. You can submit a pre-application interest form below to be
            notified when admissions open.
          </Alert>}
        {/* Admission Process Section */}
        <section className="mb-16" data-id="element-1734">
          <div className="text-center mb-10" data-id="element-1735">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1736">
              Admission Process
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1737"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1738">
              Our admission process is designed to identify students who will
              thrive in our challenging academic environment and contribute
              positively to our school community.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1739">
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 hover:shadow-md transition-shadow text-center" data-id="element-1740">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-900 text-white rounded-full mb-4" data-id="element-1741">
                <FileTextIcon className="h-8 w-8" data-id="element-1742" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1743">
                1. Application
              </h3>
              <p className="text-gray-600" data-id="element-1744">
                Complete and submit the application form with all required
                documents and application fee.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 hover:shadow-md transition-shadow text-center" data-id="element-1745">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-900 text-white rounded-full mb-4" data-id="element-1746">
                <CheckSquareIcon className="h-8 w-8" data-id="element-1747" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1748">
                2. Entrance Exam
              </h3>
              <p className="text-gray-600" data-id="element-1749">
                Qualified applicants will be invited to take an entrance
                examination to assess academic readiness.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 hover:shadow-md transition-shadow text-center" data-id="element-1750">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-900 text-white rounded-full mb-4" data-id="element-1751">
                <CalendarIcon className="h-8 w-8" data-id="element-1752" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1753">
                3. Interview
              </h3>
              <p className="text-gray-600" data-id="element-1754">
                Selected candidates and their parents will be invited for an
                interview with our admissions committee.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 hover:shadow-md transition-shadow text-center" data-id="element-1755">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-900 text-white rounded-full mb-4" data-id="element-1756">
                <CreditCardIcon className="h-8 w-8" data-id="element-1757" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1758">
                4. Acceptance
              </h3>
              <p className="text-gray-600" data-id="element-1759">
                Successful candidates will receive an offer letter and proceed
                with the enrollment process.
              </p>
            </div>
          </div>
        </section>
        {/* Tabs Section */}
        <section className="mb-16" id="requirements" data-id="element-1760">
          <Tabs tabs={[{
          id: 'requirements',
          label: 'Requirements',
          content: <div className="bg-white p-6 rounded-lg shadow" data-id="element-1762">
                    <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1763">
                      Admission Requirements
                    </h3>
                    <div className="mb-6" data-id="element-1764">
                      <h4 className="font-bold text-blue-800 mb-2" data-id="element-1765">
                        Required Documents
                      </h4>
                      <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-1766">
                        <li data-id="element-1767">Completed application form</li>
                        <li data-id="element-1768">
                          Birth certificate or passport (for age verification)
                        </li>
                        <li data-id="element-1769">Two passport-sized photographs</li>
                        <li data-id="element-1770">
                          Academic records/transcripts from previous school
                        </li>
                        <li data-id="element-1771">Letter of recommendation from previous school</li>
                        <li data-id="element-1772">Immunization records</li>
                        <li data-id="element-1773">Application fee receipt</li>
                      </ul>
                    </div>
                    <div className="mb-6" data-id="element-1774">
                      <h4 className="font-bold text-blue-800 mb-2" data-id="element-1775">
                        Age Requirements
                      </h4>
                      <p className="text-gray-700" data-id="element-1776">
                        Students entering JSS1 must be between 10-12 years of
                        age by September 1st of the academic year. Transfer
                        students to other classes must meet the corresponding
                        age requirements.
                      </p>
                    </div>
                    <div data-id="element-1777">
                      <h4 className="font-bold text-blue-800 mb-2" data-id="element-1778">
                        Academic Requirements
                      </h4>
                      <p className="text-gray-700 mb-2" data-id="element-1779">
                        Prospective students must demonstrate academic readiness
                        through:
                      </p>
                      <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-1780">
                        <li data-id="element-1781">
                          Satisfactory performance in the entrance examination
                        </li>
                        <li data-id="element-1782">Good academic standing from previous school</li>
                        <li data-id="element-1783">
                          Passing grades in core subjects (English, Mathematics,
                          Science, and Social Studies)
                        </li>
                      </ul>
                    </div>
                  </div>
        }, {
          id: 'fees',
          label: 'Tuition & Fees',
          content: <div className="bg-white p-6 rounded-lg shadow" data-id="element-1784">
                    <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1785">
                      Tuition and Fees for 2023/2024
                    </h3>
                    <div className="overflow-x-auto" data-id="element-1786">
                      <table className="min-w-full bg-white border border-gray-200" data-id="element-1787">
                        <thead data-id="element-1788">
                          <tr className="bg-blue-900 text-white" data-id="element-1789">
                            <th className="py-3 px-4 text-left" data-id="element-1790">Fee Type</th>
                            <th className="py-3 px-4 text-left" data-id="element-1791">Day Student</th>
                            <th className="py-3 px-4 text-left" data-id="element-1792">
                              Boarding Student
                            </th>
                            <th className="py-3 px-4 text-left" data-id="element-1793">
                              Payment Schedule
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200" data-id="element-1794">
                          <tr data-id="element-1795">
                            <td className="py-3 px-4 font-medium" data-id="element-1796">
                              Application Fee
                            </td>
                            <td className="py-3 px-4" data-id="element-1797">₦5,000</td>
                            <td className="py-3 px-4" data-id="element-1798">₦5,000</td>
                            <td className="py-3 px-4" data-id="element-1799">One-time</td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1800">
                            <td className="py-3 px-4 font-medium" data-id="element-1801">
                              Tuition Fee
                            </td>
                            <td className="py-3 px-4" data-id="element-1802">₦150,000</td>
                            <td className="py-3 px-4" data-id="element-1803">₦150,000</td>
                            <td className="py-3 px-4" data-id="element-1804">Per term</td>
                          </tr>
                          <tr data-id="element-1805">
                            <td className="py-3 px-4 font-medium" data-id="element-1806">
                              Boarding Fee
                            </td>
                            <td className="py-3 px-4" data-id="element-1807">N/A</td>
                            <td className="py-3 px-4" data-id="element-1808">₦120,000</td>
                            <td className="py-3 px-4" data-id="element-1809">Per term</td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1810">
                            <td className="py-3 px-4 font-medium" data-id="element-1811">
                              Development Levy
                            </td>
                            <td className="py-3 px-4" data-id="element-1812">₦25,000</td>
                            <td className="py-3 px-4" data-id="element-1813">₦25,000</td>
                            <td className="py-3 px-4" data-id="element-1814">Annual</td>
                          </tr>
                          <tr data-id="element-1815">
                            <td className="py-3 px-4 font-medium" data-id="element-1816">
                              Books & Materials
                            </td>
                            <td className="py-3 px-4" data-id="element-1817">₦40,000</td>
                            <td className="py-3 px-4" data-id="element-1818">₦40,000</td>
                            <td className="py-3 px-4" data-id="element-1819">Annual</td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1820">
                            <td className="py-3 px-4 font-medium" data-id="element-1821">Uniform</td>
                            <td className="py-3 px-4" data-id="element-1822">₦35,000</td>
                            <td className="py-3 px-4" data-id="element-1823">₦50,000</td>
                            <td className="py-3 px-4" data-id="element-1824">One-time</td>
                          </tr>
                          <tr data-id="element-1825">
                            <td className="py-3 px-4 font-medium" data-id="element-1826">
                              ICT & Lab Fee
                            </td>
                            <td className="py-3 px-4" data-id="element-1827">₦15,000</td>
                            <td className="py-3 px-4" data-id="element-1828">₦15,000</td>
                            <td className="py-3 px-4" data-id="element-1829">Per term</td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1830">
                            <td className="py-3 px-4 font-medium" data-id="element-1831">
                              Sports Fee
                            </td>
                            <td className="py-3 px-4" data-id="element-1832">₦10,000</td>
                            <td className="py-3 px-4" data-id="element-1833">₦10,000</td>
                            <td className="py-3 px-4" data-id="element-1834">Per term</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 space-y-4 text-gray-700" data-id="element-1835">
                      <p data-id="element-1836">
                        <strong data-id="element-1837">Note:</strong> All fees are subject to review. A
                        5% discount is offered for full annual payment.
                      </p>
                      <h4 className="font-bold text-blue-800" data-id="element-1838">
                        Payment Methods
                      </h4>
                      <p data-id="element-1839">Fees can be paid through:</p>
                      <ul className="list-disc list-inside space-y-1" data-id="element-1840">
                        <li data-id="element-1841">Bank transfer to our school account</li>
                        <li data-id="element-1842">
                          Direct deposit at any branch of First Bank or Zenith
                          Bank
                        </li>
                        <li data-id="element-1843">
                          Online payment through our school portal (coming soon)
                        </li>
                      </ul>
                      <p data-id="element-1844">
                        For detailed information about our payment policies,
                        please contact our finance office.
                      </p>
                    </div>
                  </div>
        }, {
          id: 'faqs',
          label: 'FAQs',
          content: <div className="bg-white p-6 rounded-lg shadow" data-id="element-1845">
                    <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1846">
                      Frequently Asked Questions
                    </h3>
                    <div className="space-y-6" data-id="element-1847">
                      <div data-id="element-1848">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1849">
                          When can I apply for admission?
                        </h4>
                        <p className="text-gray-700" data-id="element-1850">
                          Admissions for the new academic year typically open in
                          April and close in August. However, we accept transfer
                          applications throughout the year, subject to
                          availability.
                        </p>
                      </div>
                      <div data-id="element-1851">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1852">
                          What is the class size at Isonyin Grammar School?
                        </h4>
                        <p className="text-gray-700" data-id="element-1853">
                          We maintain a maximum class size of 30 students to
                          ensure quality education and individual attention.
                        </p>
                      </div>
                      <div data-id="element-1854">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1855">
                          Do you offer scholarships?
                        </h4>
                        <p className="text-gray-700" data-id="element-1856">
                          Yes, we offer merit-based and need-based scholarships.
                          Qualified candidates can apply through our scholarship
                          program. Visit our{' '}
                          <a href="/scholarships" className="text-blue-600 hover:underline" data-id="element-1857">
                            Scholarships page
                          </a>{' '}
                          for more information.
                        </p>
                      </div>
                      <div data-id="element-1858">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1859">
                          What is the admission success rate?
                        </h4>
                        <p className="text-gray-700" data-id="element-1860">
                          Our admission process is competitive, with an
                          acceptance rate of approximately 60%. We evaluate each
                          applicant holistically, considering academic
                          performance, character, and potential.
                        </p>
                      </div>
                      <div data-id="element-1861">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1862">
                          Can international students apply?
                        </h4>
                        <p className="text-gray-700" data-id="element-1863">
                          Yes, we welcome international students. Additional
                          documentation such as visa status and passport
                          information will be required during the application
                          process.
                        </p>
                      </div>
                      <div data-id="element-1864">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1865">
                          Is there a waiting list?
                        </h4>
                        <p className="text-gray-700" data-id="element-1866">
                          Yes, qualified candidates who cannot be immediately
                          admitted due to space constraints may be placed on a
                          waiting list and will be contacted if a spot becomes
                          available.
                        </p>
                      </div>
                      <div data-id="element-1867">
                        <h4 className="font-bold text-blue-800 mb-2" data-id="element-1868">
                          How can I schedule a school tour?
                        </h4>
                        <p className="text-gray-700" data-id="element-1869">
                          You can schedule a school tour by contacting our
                          admissions office at
                          <a href="mailto:admissions@isonyingrammarschool.edu.ng" className="text-blue-600 hover:underline" data-id="element-1870">
                            {' '}
                            admissions@isonyingrammarschool.edu.ng
                          </a>{' '}
                          or calling{' '}
                          <a href="tel:+2348031234567" className="text-blue-600 hover:underline" data-id="element-1871">
                            +234 (0) 803 123 4567
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
        }, {
          id: 'calendar',
          label: <div className="flex items-center" data-id="element-1872">
                    Admission Calendar
                    <Badge variant="primary" size="sm" rounded className="ml-2" data-id="element-1873">
                      New
                    </Badge>
                  </div>,
          content: <div className="bg-white p-6 rounded-lg shadow" data-id="element-1874">
                    <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1875">
                      Admission Calendar for 2023/2024
                    </h3>
                    <div className="overflow-x-auto" data-id="element-1876">
                      <table className="min-w-full bg-white border border-gray-200" data-id="element-1877">
                        <thead data-id="element-1878">
                          <tr className="bg-blue-900 text-white" data-id="element-1879">
                            <th className="py-3 px-4 text-left" data-id="element-1880">Event</th>
                            <th className="py-3 px-4 text-left" data-id="element-1881">Date</th>
                            <th className="py-3 px-4 text-left" data-id="element-1882">Details</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200" data-id="element-1883">
                          <tr data-id="element-1884">
                            <td className="py-3 px-4 font-medium" data-id="element-1885">
                              Application Portal Opens
                            </td>
                            <td className="py-3 px-4" data-id="element-1886">April 1, 2023</td>
                            <td className="py-3 px-4" data-id="element-1887">
                              Online and physical applications begin
                            </td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1888">
                            <td className="py-3 px-4 font-medium" data-id="element-1889">
                              Open House
                            </td>
                            <td className="py-3 px-4" data-id="element-1890">April 15, 2023</td>
                            <td className="py-3 px-4" data-id="element-1891">
                              School tour and information session for
                              prospective families
                            </td>
                          </tr>
                          <tr data-id="element-1892">
                            <td className="py-3 px-4 font-medium" data-id="element-1893">
                              Application Deadline
                            </td>
                            <td className="py-3 px-4" data-id="element-1894">August 15, 2023</td>
                            <td className="py-3 px-4" data-id="element-1895">
                              All applications must be submitted by this date
                            </td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1896">
                            <td className="py-3 px-4 font-medium" data-id="element-1897">
                              Entrance Examination
                            </td>
                            <td className="py-3 px-4" data-id="element-1898">August 26, 2023</td>
                            <td className="py-3 px-4" data-id="element-1899">
                              8:00 AM at the school premises
                            </td>
                          </tr>
                          <tr data-id="element-1900">
                            <td className="py-3 px-4 font-medium" data-id="element-1901">
                              Interviews
                            </td>
                            <td className="py-3 px-4" data-id="element-1902">September 4-8, 2023</td>
                            <td className="py-3 px-4" data-id="element-1903">By appointment only</td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1904">
                            <td className="py-3 px-4 font-medium" data-id="element-1905">
                              Admission Decisions
                            </td>
                            <td className="py-3 px-4" data-id="element-1906">September 15, 2023</td>
                            <td className="py-3 px-4" data-id="element-1907">
                              Results will be communicated via email and SMS
                            </td>
                          </tr>
                          <tr data-id="element-1908">
                            <td className="py-3 px-4 font-medium" data-id="element-1909">
                              Acceptance Deadline
                            </td>
                            <td className="py-3 px-4" data-id="element-1910">September 30, 2023</td>
                            <td className="py-3 px-4" data-id="element-1911">
                              Accepted students must confirm enrollment by this
                              date
                            </td>
                          </tr>
                          <tr className="bg-gray-50" data-id="element-1912">
                            <td className="py-3 px-4 font-medium" data-id="element-1913">
                              New Student Orientation
                            </td>
                            <td className="py-3 px-4" data-id="element-1914">October 7, 2023</td>
                            <td className="py-3 px-4" data-id="element-1915">
                              Mandatory for all new students and their parents
                            </td>
                          </tr>
                          <tr data-id="element-1916">
                            <td className="py-3 px-4 font-medium" data-id="element-1917">
                              First Day of School
                            </td>
                            <td className="py-3 px-4" data-id="element-1918">October 9, 2023</td>
                            <td className="py-3 px-4" data-id="element-1919">
                              Beginning of 2023/2024 academic session
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6" data-id="element-1920">
                      <p className="text-gray-700" data-id="element-1921">
                        <strong data-id="element-1922">Note:</strong> Dates are subject to change.
                        Please check our website regularly for updates.
                      </p>
                    </div>
                  </div>
        }]} variant="boxed" className="mb-8" data-id="element-1761" />
        </section>
        {/* Application Form Section */}
        <section className="mb-16" id="apply" data-id="element-1923">
          <div className="text-center mb-10" data-id="element-1924">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1925">Apply Now</h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1926"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1927">
              Take the first step towards joining Isonyin Grammar School by
              submitting your application.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-1928">
            <AdmissionForm data-id="element-1929" />
          </div>
        </section>
        {/* Testimonials Section */}
        <section data-id="element-1930">
          <div className="text-center mb-10" data-id="element-1931">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1932">
              What Our Students Say
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1933"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1934">
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 relative" data-id="element-1935">
              <div className="absolute -top-4 -left-4 text-6xl text-yellow-500 opacity-50" data-id="element-1936">
                "
              </div>
              <div className="relative z-10" data-id="element-1937">
                <p className="text-gray-700 italic mb-4" data-id="element-1938">
                  The admission process was straightforward and the staff was
                  incredibly helpful. They guided us through every step and made
                  us feel welcome. I'm so grateful my son is now part of this
                  amazing school.
                </p>
                <div className="flex items-center" data-id="element-1939">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg" alt="Parent" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1940" />
                  <div data-id="element-1941">
                    <h4 className="font-bold text-blue-900" data-id="element-1942">
                      Mrs. Adebola Johnson
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-1943">
                      Parent of JSS1 Student
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 relative" data-id="element-1944">
              <div className="absolute -top-4 -left-4 text-6xl text-yellow-500 opacity-50" data-id="element-1945">
                "
              </div>
              <div className="relative z-10" data-id="element-1946">
                <p className="text-gray-700 italic mb-4" data-id="element-1947">
                  I was nervous about the entrance exam, but the teachers made
                  me feel comfortable. Now that I'm a student here, I love the
                  challenging classes and all the extracurricular activities
                  available.
                </p>
                <div className="flex items-center" data-id="element-1948">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg" alt="Student" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1949" />
                  <div data-id="element-1950">
                    <h4 className="font-bold text-blue-900" data-id="element-1951">Chioma Nwosu</h4>
                    <p className="text-sm text-gray-500" data-id="element-1952">
                      Current JSS2 Student
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default Admissions;